//vendor
import { warehouseOptions } from '@/vendor/HubspotFormIntegration';

//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';
import { SidePanels } from '@/containers/SidePanels';
import { HubspotFormSimplified } from '@/containers-m/HubspotFormSimplified';

// context containers
import {
  CTASection,
  FloatHeroBox,
  Hero,
  IconSection,
  IntroductionText,
} from './containers/index';

//styles
import { PageWrapper, HubspotFormWrapper } from './Warehouse.styles';

//data
const side_panels = {
  title: null,
  subtitle: null,
  features: [
    {
      title: 'Online Carrier Scheduling',
      logo: null,
      subtitle: null,
      content: (
        <>
          <p>
            Carriers and brokers can instantly find warehouses, get
            availability, and schedule an appointment entirely online without
            the back and forths of phone calls and emails.
          </p>
          <ul>
            <li>Save time spent on phone calls and emails</li>
            <li>Efficiently reallocate labor to value-add tasks</li>
            <li>Create a consistent, reliable experience for your partners</li>
          </ul>
        </>
      ),
      link: {
        external: true,
        url: 'https://carrier.opendock.com/app/login',
        label: 'Create Your Free Carrier Account',
      },
      image: {
        path: {
          small: '/images/warehouse/features/opendock-appointments-sm-1.png',
          medium: '/images/warehouse/features/opendock-appointments-md-1.png',
          large: '/images/warehouse/features/opendock-appointments-lg-1.png',
          xxlarge:
            '/images/warehouse/features/opendock-appointments-xxlg-1.png',
        },
        alt: 'Opendock appointments Dashboard',
      },
    },
    {
      title: 'Appointment View',
      logo: null,
      subtitle: null,
      content: (
        <>
          <p>
            View your schedule with insight into which carrier is coming in,
            what time they are coming in, and which load type they are bringing
            with them.
          </p>
          <ul>
            <li>Drag and drop calendar grid</li>
            <li>Easy and simple interface</li>
            <li>Updated in real-time, no need to constantly refresh</li>
          </ul>
        </>
      ),
      link: {
        external: false,
        url: '#request-a-demo',
        label: 'Take Control of Your Facilities',
      },
      image: {
        path: {
          small: '/images/warehouse/features/opendock-calendar-sm.png',
          medium: '/images/warehouse/features/opendock-calendar-md.png',
          large: '/images/warehouse/features/opendock-calendar-lg.png',
          xxlarge: '/images/warehouse/features/opendock-calendar-xxlg.png',
        },
        alt: 'Opendock calendar view',
      },
    },
    {
      title: 'Automated Reporting',
      logo: null,
      subtitle: null,
      content: (
        <>
          <p>
            Easy to read dashboards with important KPIs or option to build your
            own customized report by selecting from available appointment fields
            and metrics that can be saved for your convenience.
          </p>
          <ul>
            <li>Measure and track warehouse performance</li>
            <li>Measure and track carrier performance</li>
            <li>One-click excel reports</li>
          </ul>
        </>
      ),
      link: {
        external: false,
        url: '#request-a-demo',
        label: 'Unlock Insights Now',
      },
      image: {
        path: {
          small: '/images/warehouse/features/opendock-insights-sm.png',
          medium: '/images/warehouse/features/opendock-insights-md.png',
          large: '/images/warehouse/features/opendock-insights-lg.png',
          xxlarge: '/images/warehouse/features/opendock-insights-xxlg.png',
        },
        alt: 'Opendock insights reports',
      },
    },
  ],
};

const form_content = {
  title: <>Save time and money by having your carriers book online.</>,
  subtitle: (
    <>
      Kick that old, painful process to the curb, and move to online dock
      schedueling.
    </>
  ),
};

function Warehouse() {
  return (
    <PageWrapper>
      <Navigation />
      <>
        <Hero />
        <FloatHeroBox />
        <IntroductionText />
        <SidePanels content={side_panels} />
        <CTASection />
        <IconSection />
        <HubspotFormWrapper id="request-a-demo">
          <HubspotFormSimplified content={form_content} {...warehouseOptions} />
        </HubspotFormWrapper>
      </>
      <Footer />
    </PageWrapper>
  );
}

export default Warehouse;
export { Warehouse };
